import { keyframes } from '@emotion/react';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

type SpinnerProps = {
  size?: number;
  color?: string;
  strokeWidth?: number;
};

const SpinnerIcon = ({ size = 16, color = 'currentColor', strokeWidth = 2 }: SpinnerProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        animation: `${spin} 0.8s linear infinite`,
      }}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        sx={{
          opacity: 0.25,
        }}
      />
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        sx={{
          strokeDasharray: 60,
          strokeDashoffset: 45,
        }}
      />
    </svg>
  );
};

export default SpinnerIcon;
